import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import "@/vantui"
import "vant/lib/index.css"

import "@/assets/js/font-base"  //通过js智能加载页面字体显示
import "@/assets/fonts/iconfont.css"  //iconfont图标
import "@/assets/huitongFont/iconfont.css"  //iconfont图标
import "@/assets/css/common.css";
import "@/assets/css/animation.css";
import "@/assets/css/base.scss";  //样式文件

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: false
})

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import { Lazyload, Toast } from 'vant';
Vue.use(Lazyload);
Vue.use(Toast);
Vue.prototype.$toast = Toast

/**
 * 防抖
 */
Vue.prototype._debounce = function(func, wait = 1000, immediate = true) {
	let timeout;
	return function() {
		let context = this;
		let args = arguments;
		clearTimeout(timeout);

		if (immediate) {
			let calling = !timeout;
			timeout = setTimeout(function() {
				timeout = null;
			}, wait);
			if (calling) {
				return func.apply(context, args);
			}
		} else {
			timeout = setTimeout(function() {
				func.apply(context, args);
			}, wait);
		}
	}
}

/* Viewer.setDefaults({
  // 需要配置的属性 注意属性并没有引号
  title: false,
  toolbar: false
}) */
import api from '@/api';
Vue.prototype.$api = api; // 将api挂载到vue的原型上

import '@/filter'  // 引入自定义过滤器
import utils from '@/utils';  //引入自定义小工具方法
Vue.prototype.$utils = utils;


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
